module.exports = __webpack_public_path__ + "static/media/ai.94223c3a.svg";